module.exports = __webpack_public_path__ + "static/media/arrow-up-stroke.f1d0e4cf.svg";